import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ImportarDireccionesExcel from '../../components/importarDireccionesExcel/ImportarDireccionesExcel'
import {submitImportarDireccionesExcel, cerrarModalImportarDireccionesExcel, subirArchivosImportarDireccionesExcel, abrirModalImportarDireccionesExcel, descargarPlantillaExcelDireccionesExcel} from '../../actions/importarDireccionesExcel/importarDireccionesExcel'

export function mapStateToProps (state) {
  return {
    ...state.importarDireccionesExcel,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      submitImportarDireccionesExcel,
      cerrarModalImportarDireccionesExcel,
      subirArchivosImportarDireccionesExcel,
      abrirModalImportarDireccionesExcel,
      descargarPlantillaExcelDireccionesExcel
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ImportarDireccionesExcel))